module.exports = __webpack_public_path__ + "static/media/EarthDayRecipeBook2017.9b9fe2d3.PNG";